import PropTypes from 'prop-types';
import classNames from 'classnames';
import CSSModules from 'react-css-modules';
import useMediaQuery from 'modules/Business/hooks/useMediaQuery';
import { bemModifier } from 'utils/BEMHelper';

import styles from './ProgressBar.scss';

const ProgressBar = ({ activeIndex, status }) => {
  const lineWidth = 100 / (status.length - 1);
  const getBemModifier = (className, modifiers) =>
    classNames(...bemModifier(`a-progress-bar__${className}`, modifiers));
  const { isMobile } = useMediaQuery();

  return (
    <ul styleName="a-progress-bar">
      {status.map(({ label }, index) => {
        const completed = activeIndex > index;
        const active = activeIndex === index;
        const isLast = index >= status.length - 1;

        return (
          <li
            key={index}
            style={isLast ? {} : { width: `${lineWidth}%` }}
            styleName={getBemModifier('step', { active, completed })}
          >
            {!isLast && <div styleName={getBemModifier('line', { completed })} />}

            <span styleName={getBemModifier('label', { active, completed })}>
              {isMobile && !active ? '' : label}
            </span>
          </li>
        );
      })}
    </ul>
  );
};

ProgressBar.propTypes = {
  activeIndex: PropTypes.number.isRequired,
  status: PropTypes.arrayOf(
    PropTypes.shape({
      active: PropTypes.boolean,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default CSSModules(ProgressBar, styles, { allowMultiple: true });
